<!--suppress ALL -->
<script lang="ts">
import {months} from '../../../util/PluralVariabels';
  import {Component, Vue, Prop} from 'annotation';
  import {cloneArray} from "../../../util/Underscore";

  import GField from '../common/field/GField.vue';
  import GSelect from '../common/select/GSelect.vue';

  @Component
  export default class MonthSelect extends Vue {

    @Prop({default: months[0].value, type: String})
    public bulan: string;

    @Prop({default: false, type: Boolean})
    public skipLabel: boolean;

    @Prop({default: true, type: Boolean})
    public isFullwidth: boolean;

    @Prop({type: String, default: null})
    public type: any;

    @Prop({type: String, default: null})
    public message: any;

    @Prop({type: Boolean, default: false})
    public disabled: any;

    public onSelectMonth(param: any) {
      this.$emit('update:month', param.value || months[0].value);
      this.$emit('selected', param);
    }

    public render(createElement: Function) {
      const {$t, bulan, isFullwidth, message, type} = this;

      const mainAttr: any = {
        props: {
          value: bulan,
          isFullwidth, placeholder: `${$t('label.choose')} ${$t('label.month')}`
        },
        attrs: {disabled: this.disabled},
        on: {change: this.onSelectMonth}
      };

      const main: any = createElement(GSelect, mainAttr, cloneArray(months).map((item: any) => {
        const option: any = {attrs: {value: item.value}};

        return createElement('option', option, item.name.toUpperCase());
      }));

      if (this.skipLabel) {
        return main;
      }

      return createElement(GField, {props: {label: $t('label.month'), message, type}}, [main]);
    }
  }
</script>
